<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Support Us">
                    <div>
                        <AmountSelector/>                    
                        <ErrorLabel field="amount" />
                        <br/>
                        <ShortNote/>                    
                    </div>
                </FormSection>
                <FormSection v-if="form.amount">
                  <TransactionFee />
                </FormSection>
                <FormSection title="Donation Frequency">
                  <DonationFrequency />
                </FormSection>
                <FormSection title="Please designate my gift to:">
                  <FormRow class="designation" inline>
                  <FormCol field="custom.designation" width="half" :showLabel="false">
                    <FormSelect>
                      <option selected="selected" value="Wherever it is needed most">
                        Wherever it is needed most
                      </option>
                      <option value="Upper Boys School – Brooklyn">Upper Boys School – Brooklyn</option>                   
                      <option value="Upper & Middle Girls School – Brooklyn">Upper & Middle Girls School – Brooklyn</option>
                      <option value="Elementary School – Five Towns">Elementary School – Five Towns</option>
                      <option value="Upper Boys School – Lakewood">Upper Boys School – Lakewood</option>   
                    </FormSelect>
                  </FormCol>
                  </FormRow>
                </FormSection>                
                <FormSection title="Your Details">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow> 
                    <FormRow>
                      <FormLabel>
                          <NewsletterSubscribe text="Click here if you want to sign up for our newsletter." />
                      </FormLabel>
                    </FormRow>   
                    <br/>
                    <InHonorOf />
                </FormSection>                
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                <FormRow>
                  <Receipt :receipts="['canadian', 'us']" />
                </FormRow>                
                </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { onMounted } from 'vue'
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { setValue, form, submit } = usePaymentForm()

    if (props.subCampaign) {
      setValue('applications.0.subCampaign', props.subCampaign)
    }

    onMounted(() => {
      const params = queryParams()

      if (params.utm_content) {
        if (
          !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
            params.utm_content
          )
        ) {
          throw new Error('Invalid subcampaign')
        }

        setValue('applications.0.subCampaign', params.utm_content)
      }
    })

    return {
      form,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}

::v-deep .styled-radio.styled-radio--ou-donation,
::v-deep .styled-radio-container--ou-donation.styled-radio-container {


  // label {
  //   background: #fff;
  //   border: 1px solid #ddd;
  //   font-weight: bold;
  //   color: rgb(87, 87, 87);
  //   width: 100%;
  //   border-radius: 4px;
  //   cursor: pointer;
  //   display: block;
  //   height: 100%;
  //   display: flex;
  //   overflow: hidden;
  // }
  input[type='radio']:checked + label {
    background: #805397;
    color: white;
  }
  input[type='radio']:checked + label .label-amount {
    background: #805397;
    border-color: #805397;
  }
  label:hover {
    background: #e9f0f7;
  }
}

::v-deep .ou-donation-btn{
    border: 1px solid #805397;
    background: #805397;
}
</style>

